import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import ManageTeamMember from './ManageTeamMember'

const List = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  padding: '0px 0px 8px',
  position: 'relative',
  width: '100%',
  minHeight: 0 // required for FF68
})






const ManageTeamList = (props) => {
  const {manageTeamMemberId} = props
  const team = useFragment(
    graphql`
      fragment ManageTeamList_team on Team {
        isViewerLead
        isOrgAdmin
        teamMembers(sortBy: "preferredName") {
          id
          preferredName
          ...ManageTeamMember_teamMember
        }
      }
    `,
    props.team
  )
  const {isViewerLead, isOrgAdmin: isViewerOrgAdmin, teamMembers} = team
  return (
    React.createElement(List, null
      , teamMembers.map((teamMember) => {
        return (
          React.createElement(ManageTeamMember, {
            key: teamMember.id,
            isViewerLead: isViewerLead,
            isViewerOrgAdmin: isViewerOrgAdmin,
            manageTeamMemberId: manageTeamMemberId,
            teamMember: teamMember,}
          )
        )
      })
    )
  )
}

export default ManageTeamList
